
import React, { useEffect } from "react";
import home from "../assets/smart.JPG";
import smart from "../assets/smartPos.JPG";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../styles/Merchant.module.css";
import payment from "../assets/merchants.png";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const MerchantApp = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <Header />
      <div>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundImage:
                "linear-gradient(to bottom, #e0ffe0, transparent)",
              marginBottom: "20px",
              padding: "30px 20px",
            }}
          >
            <div
              className={styles.merchantTop}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              <div className={styles.merchantAppInfo}>
                <div
                  className={styles.info}
                  style={{
                    textAlign: "left",
                    flex: 1,
                    marginBottom: "20px",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      overflow: "hidden",
                      fontSize: "30px",
                      color: "green",
                      marginTop: "0",
                      marginBottom: "10px",
                      lineHeight: 1.2,
                      fontWeight: 700,
                    }}
                  >
                    ARIFPOS
                  </p>
                  <h1
                    style={{
                      overflow: "hidden",
                      fontSize: "28px",
                      color: "black",
                      marginTop: "0",
                      marginBottom: "10px",
                      lineHeight: 1.2,
                      fontWeight: 600,
                    }}
                  >
                    Smart POS Machine with Multi-Wallet Payments & Terminal Management
                  </h1>
                </div>
                <div
                  className={styles.inform}
                  style={{
                    textAlign: "left",
                    flex: 1,
                    marginBottom: "0",
                    width: "100%",
                  }}
                >
                  <p style={{ color: "black", fontSize: "17px" }}>
                    Accept in-store payments from multiple wallets and banks on
                    one Arif POS machine. Monitor, configure, and control every
                    terminal from Arifpay's terminal management system.
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginRight: "200px",
                marginLeft: "auto",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <div className={styles.buttons}>
                <Link to="/ContactUs">
                  <button className={styles.fullWidthButton}>
                    Contact Sales →
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                className={styles.images}
                style={{
                  width: "100%",
                  // height: "450px",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={home}
                  alt="mobile pos"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "450px",
                    objectFit: "cover",
                    borderRadius: "35px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <section
          className={styles.dev}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div
            className={styles.viewText}
            style={{ flex: 1, maxWidth: "800px" }}
          >
         <h3
             style={{
               fontSize: "25px",
               color: "green",
               // marginLeft:"100px",
               textAlign: "center",
               marginBottom: "20px",
             }}
           >
             Why Choose ArifPOS?
           </h3>

           <p
             style={{
               fontSize: "20px",
               textAlign: "center",
               color: "black",
               marginBottom: "23px",
             }}
           >
             ArifPOS integrates value-added applications with payments,
             connecting you to an extensive
            {/* <span className={styles.viewBreak}> <br /></span> */}
             network of partners worldwide. Cloud-based Android architecture
             makes it easy for
             {/* <br /> */}
             developers to implement business apps. And merchants benefit from
             cutting-edge services
             {/* <br /> */}
             at an affordable price.
          </p>
          </div>
        </section>

        <div>
         <section className={styles.domesticPaymentsSection} style={{
  display: "flex",
  justifyContent: "center",
  width: "100%",
  padding: "40px 0",
}}>
  <div className={styles.paymentBox} style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "80px",
    maxWidth: "1400px",
    width: "100%",
   
  }}>
    {/* Left Content */}
    <div className={styles.leftContent} style={{
          textAlign: "center",
      flex: 1,
      maxWidth: "500px",
    }}>
      {/* <img src={tarns} style={{ marginBottom: "0", marginTop: 0 }} /> */}
      <h4 style={{
        textAlign:"left",
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
      }}>
       Multi-Payment Acceptance
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
       Arif Smart POS accepts all major payment types, including cards, mobile wallets, customer presented QR codes, and cash giving your customers full flexibility at checkout.
      </p>

      {/* <img src={secure} style={{ marginBottom: "5px", marginTop: "10px" }} /> */}
      <h4 style={{
        textAlign:"left",
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
      }}>
      Built-In Cash Register Functions
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
       It includes built-in cash register functionality, allowing businesses to track cash payments, manage drawers, apply discounts, and print or send digital receipts with ease.
      </p>

      {/* <img src={trans} style={{ marginBottom: "0", marginTop: 0 }} /> */}
      <h4 style={{
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
        textAlign:"left",
      }}>
      Real-time analytics and reporting
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
       The system provides real-time analytics and reporting, enabling you to monitor sales performance, payment trends, and customer behavior all from a centralized dashboard.
      </p>

  
    </div>

    {/* Right Content */}
    <div className={styles.rightContent} style={{
      textAlign: "center",
      flex: 1,
      maxWidth: "500px",
    }}>

          {/* <img src={secured} style={{ marginBottom: "5px", marginTop: "10px" }} /> */}
      <h4 style={{
        textAlign:"left",
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
      }}>
      Inventory Management
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
      Stock levels are automatically updated with every sale, allowing you to track product availability in real time and receive instant alerts when inventory is running low ensuring you never miss a sale.
      </p>
      {/* <img src={managed} style={{ marginBottom: "0", marginTop: 0 }} /> */}
      <h4 style={{
        textAlign:"left",
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
      }}>
      Secure and Offline Capable
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
       Security is built-in, with end-to-end encryption, offline payment support, remote software updates, and full compliance with international standards like PCI-DSS.
      </p>

      {/* <img src={report} style={{ marginBottom: "0", marginTop: "10px" }} /> */}
      <h4 style={{
        textAlign:"left",
        fontSize: "20px",
        color: "green",
        marginBottom: "20px",
      }}>
      User-friendly and Configurable
      </h4>
      <p style={{
        textAlign:"left",
        fontSize: "16px",
        color: "black",
        marginBottom: "30px",
        lineHeight: "1.6",
      }}>
      Designed to be user-friendly and adaptable, the POS features a simple touchscreen interface, multilingual support, role-based access, and customizable settings to suit different business needs.
      </p>

  
    </div>
  </div>
</section>

          <div
            className={styles.bottom}
            style={{
              backgroundColor: "#8bc34a",
              color: "#fff",
              padding: "20px",
              borderRadius: "30px",
              marginBottom: "40px",
              marginTop: "50px",
              marginRight: "40px",
              marginLeft: "40px",
            }}
          >
            <div
              style={{
                maxWidth: "1400px",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div className={styles.getApp} style={{ flex: "1 1 500px", marginBottom: "10px" }}>
                <h2
                  style={{
                    fontSize: "25px",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    color: "white",
                  }}
                >
               Built for businesses that don’t stand still
                </h2>
                <p
                  style={{
                    fontSize: "1em",
                    lineHeight: "1.6",
                    marginBottom: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      verticalAlign: "middle",
                      marginRight: "5px",
                    }}
                  >
                    ✦
                  </span>
                  Whether you’re running a shop, managing deliveries, or scaling across multiple locations, ArifPOS helps you take payments anywhere with the flexibility, speed, and support you need to grow.
                </p>
                <div
                  className={styles.but}
                  style={{ display: "flex", gap: "15px" }}
                >
                     <Link to="/pages/ContactUs">
                     <button
                       style={{
                         backgroundColor: "#fff",
                         color: "green",
                         border: "none",
                         padding: "15px 30px",
                         borderRadius: "5px",
                         fontSize: "16px",
                         fontWeight: "bold",
                         cursor: "pointer",
                       }}
                     >
                       Contact Us
                     </button>
                   </Link>
           
                </div>
              </div>
              <div
                className={styles.image}
                style={{
                  flex: "1 1 400px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={smart}
                  alt="App on Laptop"
                  style={{
                    maxWidth: "400px",
                    height: "250px",
                    borderRadius: "10px",
                    justifyContent: "flex-end",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MerchantApp;
